import { NavMarker } from 'react-rhumb';
import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIList from 'UIComponents/list/UIList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import EmptyStateListItem from 'FormsUI/components/dashboard/zeroState/EmptyStateListItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmptyState = () => {
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "FORMS_DASHBOARD_ZERO_STATE",
    children: /*#__PURE__*/_jsx(UIEmptyState, {
      maxWidth: 680,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.zeroState.createFreeForm"
      }),
      primaryContent: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsx(EmptyStateListItem, {
          content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "dashboard.zeroState.getStartWithTemplate"
          })
        }), /*#__PURE__*/_jsx(EmptyStateListItem, {
          content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "dashboard.zeroState.shareOrEmbed"
          })
        }), /*#__PURE__*/_jsx(EmptyStateListItem, {
          content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "dashboard.zeroState.followUp"
          })
        })]
      }),
      secondaryContent: /*#__PURE__*/_jsx(UIIllustration, {
        name: "forms-success",
        width: "100%"
      }),
      secondaryContentWidth: 150
    })
  });
};
export default EmptyState;